import { isStoredNicknamePatternValid } from '@utils/nickname';
import { normalizeStateRoutePath } from '@state-routing/config/state-routing.config';

export type ProfilePathParams = {
  userId?: number | null;
  nickname?: string | null;
};

export const buildProfilePath = (params: ProfilePathParams): string | null => {
  const nickname = (params.nickname ?? '').trim();
  if (isStoredNicknamePatternValid(nickname)) {
    return `/@${nickname}`;
  }

  const userId = params.userId;
  if (typeof userId === 'number' && Number.isFinite(userId) && userId > 0) {
    return `/people/${userId}`;
  }

  return null;
};

export const isProfilePathForUser = (
  url: string,
  params: ProfilePathParams,
  currentUserId: number | null,
): boolean => {
  const path: string = normalizeStateRoutePath(url);
  const userId: number | null = typeof params.userId === 'number' ? params.userId : null;
  if (path === '/profile') {
    return userId !== null && userId === currentUserId;
  }

  const peopleRouteMatch: RegExpMatchArray | null = path.match(/^\/people\/(\d+)$/);
  if (peopleRouteMatch !== null) {
    return userId !== null && Number(peopleRouteMatch[1]) === userId;
  }

  const nickname: string = (params.nickname ?? '').trim();
  return isStoredNicknamePatternValid(nickname)
    && path.toLowerCase() === `/@${nickname}`.toLowerCase();
};

export const findProfilePathForUser = (
  urls: readonly (string | null | undefined)[],
  params: ProfilePathParams,
  currentUserId: number | null,
): string | null => {
  return urls.find((url: string | null | undefined): url is string => (
    typeof url === 'string' && isProfilePathForUser(url, params, currentUserId)
  )) ?? null;
};
